import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";

interface Props {
  onTapCloseModal: () => void;
}
// 利用者統合モーダル
export const UserIntegrationCompletedModal = ({ onTapCloseModal }: Props) => {

  return (
    <BasePageModal
      title="ユーザーの統合"
      className="md-user-integrat"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="閉じる"
          onClick={onTapCloseModal}
        />
      }
    >
      <h2>
        ユーザーの統合が完了しました
      </h2>
    </BasePageModal>
  );
};
